// Import core React libraries
import React, { useCallback, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { MdAddBox } from "react-icons/md";

import { ErrorMessage, Loading, ProgramDetail } from "../../components";

import * as select from "../../reducers";
import * as actionsModals from "../../actions/modals";

// Import styling
import "../../styles/components/_programs.scss";
import { fetchPrograms, setSelectedProgram } from "../../actions/programs";
import { useNavigate } from "react-router-dom";

function Programs({
  programs,
  programsLoading,
  programsError,
  setModalProgramEditOpen,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchPrograms());
  }, [dispatch]);

  const handleNewPayment = useCallback(() => {
    navigate("/payment");
  }, [navigate]);

  if (programsError) {
    return <ErrorMessage title={programsError} />;
  }

  return (
    <div>
      <h1 className="white">Current Financial Partnerships</h1>
      {programsLoading && (
        <div className="program-loading">
          <Loading variant="inline" />
        </div>
      )}
      <div className="program-grid">
        {!programsLoading &&
          programs.map((program, i) => {
            return (
              <ProgramDetail
                key={i}
                {...program}
                onSelect={() => {
                  dispatch(setSelectedProgram(program.donation_id));
                  setModalProgramEditOpen();
                }}
              />
            );
          })}
        {!programsLoading && (
          <div onClick={handleNewPayment} className="program program--new">
            <div className="program__wrap">
              <div className="program__new-inset">
                <div className="dashed-line--top" />
                <div className="dashed-line--right" />
                <div className="dashed-line--bottom" />
                <div className="dashed-line--left" />
                <MdAddBox className="program__add-new-btn" size={60} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    programs: select.getPrograms(state),
    programsError: select.getProgramsError(state),
    programsLoading: select.getProgramsLoading(state),
    selectedProgram: select.getSelectedProgram(state),
    isAuthed: select.getIsLoggedIn(state),
    authedUserId: select.getSessionUserId(state),
  };
};

export default connect(mapStateToProps, {
  ...actionsModals,
})(Programs);
